import { render } from "./Room.vue?vue&type=template&id=53f046c8&ts=true&lang=pug"
import script from "./Room.vue?vue&type=script&lang=ts"
export * from "./Room.vue?vue&type=script&lang=ts"

import "./Room.vue?vue&type=style&index=0&id=53f046c8&lang=scss"

import exportComponent from "/Users/olimago/Documents/www/escape-if-you-can-01/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__